var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowKeyvisualNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1038,
    viewBox: "0 0 3200 1038",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1037.92,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L3200 0.677717V1037.92H0L0 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 1600,
    cy: 831.5,
    rx: 388.182,
    ry: 55.5806,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.06,
    cx: 1600,
    cy: 831.5,
    rx: 854,
    ry: 122.277,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: 1600,
    cy: 831.5,
    rx: 621.091,
    ry: 88.9289,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 2063,
    cy: 579.433,
    rx: 268.636,
    ry: 38.4638,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.06,
    cx: 2063,
    cy: 579.433,
    rx: 591,
    ry: 84.6205,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: 2063,
    cy: 579.433,
    rx: 429.818,
    ry: 61.5421,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1614.58 217.026C1623.82 234.24 1622.72 277.906 1610.79 280.982C1606.03 282.209 1595.89 279.204 1585.57 272.984L1592.04 318.812H1553.79L1566.96 257.436C1559.62 248.816 1554.65 238.252 1555.48 226.416C1557.87 192.309 1605.35 199.812 1614.58 217.026Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1599.48 198.278C1572.92 188.354 1552.09 207.529 1549.33 210.686C1546.4 214.032 1544.45 218.213 1543.01 222.466C1541.45 227.085 1540.48 231.885 1540.12 236.775C1539.78 241.421 1539.75 246.335 1540.84 250.882C1541.86 255.135 1544.04 258.623 1547.67 260.836C1549.34 261.85 1551.13 262.612 1552.94 263.308C1554.71 263.994 1556.5 264.661 1558.36 265.045C1561.88 265.774 1565.94 265.649 1568.66 262.844C1569.63 261.833 1570.71 260.563 1571.42 259.328C1571.68 258.884 1571.83 258.593 1571.52 258.159C1571.15 257.639 1570.54 257.241 1570.06 256.834C1567.33 254.515 1565.64 251.419 1565.21 247.74C1564.78 244.007 1565.78 239.188 1569.41 237.559C1573.89 235.548 1578.82 237.856 1582.8 240.008C1584.5 234.035 1587.97 228.657 1593.42 225.917C1599.45 222.886 1606.36 222.531 1612.56 219.931C1614.17 219.253 1615.81 218.484 1617 217.103C1617.5 216.526 1618.08 215.777 1618.28 215.014C1618.54 214.011 1617.89 213.171 1617.39 212.389C1614.75 208.245 1609.59 202.058 1599.48 198.278Z",
    fill: "#A55728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555.39 216.812C1568.59 216.812 1579.29 206.109 1579.29 192.906C1579.29 179.703 1568.59 169 1555.39 169C1542.18 169 1531.48 179.703 1531.48 192.906C1531.48 206.109 1542.18 216.812 1555.39 216.812Z",
    fill: "#A55728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1550.5 258.457C1541.89 278.819 1533.96 292.358 1526.71 299.075C1529.89 305.822 1539.93 308.79 1556.83 307.978L1566.39 263.256L1550.5 258.457Z",
    fill: "#A55728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1541.04 451.094L1599.42 652.268L1626.88 803.312H1654.44L1626.93 451.094H1541.04Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1541.04 451.094L1599.42 652.268L1626.88 803.312H1654.44L1626.93 451.094H1541.04Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1514.81 451.094C1518.88 555.603 1517.27 612.605 1516.36 622.1C1515.45 631.595 1510.27 695.187 1475 806.5H1503.67C1550.38 699.714 1566.68 636.122 1572.04 622.1C1577.4 608.077 1593.22 551.075 1616.32 451.094H1514.81Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1539.79 451.094C1554.98 520.318 1581.24 630.818 1618.58 782.594H1658.89C1661.87 626.811 1649.21 524.28 1627.27 451.094H1539.79Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1514.6 451.094C1518.59 555.603 1508.25 658.564 1476.23 784.221H1519.23C1566.03 679.028 1599.57 576.575 1622.49 451.094H1514.6Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1470.92 827.219L1472.5 801.719C1481.76 804.427 1493.36 803.365 1507.3 798.531C1522.28 809.147 1541.15 816.395 1563.89 820.277C1565.63 820.573 1566.79 822.22 1566.5 823.955C1566.48 824.067 1566.45 824.179 1566.42 824.288L1564.24 832H1507.3H1474.08L1470.92 827.219Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1620.73 827.219L1622.31 801.719C1631.57 804.427 1643.17 803.365 1657.11 798.531C1672.1 809.147 1690.96 816.395 1713.71 820.277C1715.44 820.573 1716.61 822.22 1716.31 823.955C1716.29 824.067 1716.27 824.179 1716.24 824.288L1714.05 832H1657.11H1623.89L1620.73 827.219Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1480.97 432L1514.28 432.131C1493.71 498.516 1482.61 533.74 1480.97 537.802C1477.28 546.941 1485.09 560.86 1488.43 568.34C1477.56 573.204 1478.71 555.192 1465 561.571C1452.49 567.393 1442.97 577.943 1428.51 569.021C1426.73 567.924 1424.78 563.794 1429.49 560.567C1441.21 552.526 1458.11 538.454 1460.4 533.822C1463.51 527.505 1470.37 493.564 1480.97 432ZM1681.36 425.788L1726.51 469.831C1739.65 475.435 1750.41 481.622 1758.8 488.393C1760.69 490.669 1762.74 495.03 1753.87 493.078C1744.99 491.127 1735.56 489.474 1733.89 492.361C1732.22 495.248 1737.14 499.672 1734.06 503.45C1732 505.969 1725.09 497.957 1713.32 479.413L1666.37 451.734L1681.36 425.788Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1575.62 292.247L1589.4 289.884C1613.13 349.156 1654.55 403.012 1713.68 451.452L1669 505.729C1609.88 436.757 1573.44 365.596 1575.62 292.247Z",
    fill: "#56919C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1515.54 465.437H1638.26C1609.83 396.309 1595.62 337.585 1595.62 289.266L1558.6 283.75C1529.5 330.54 1521.29 388.148 1515.54 465.437Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.24 283.75C1563.14 283.85 1567.54 284.029 1573.46 284.288L1582.4 309.851C1583.35 341.017 1588.87 403.826 1598.98 498.278L1518.53 498.278C1518.74 504.801 1519.09 511.386 1519.58 518.031H1459.76C1468.71 417.089 1501.38 338.996 1557.78 283.75L1557.81 283.777L1557.83 283.75H1560.24Z",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1541.04 498.905L1518.55 498.904C1517.57 469.649 1519.33 441.618 1523.85 414.811C1526.14 455.473 1531.87 483.505 1541.04 498.905Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1536.44 449.5L1576.11 431.06V449.5H1536.44Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2044.31 101.77C2037.15 115.128 2038 149.012 2047.26 151.399C2050.95 152.352 2058.82 150.019 2066.83 145.192L2061.8 180.755H2091.49L2081.27 133.128C2086.97 126.439 2090.82 118.241 2090.18 109.056C2088.32 82.5894 2051.48 88.4118 2044.31 101.77Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2066.75 88C2050.84 88 2044.8 94.5624 2044.49 100.367C2051.31 102.242 2063.23 102.964 2080.35 102.841V104.078L2065.51 105.314L2063.04 112.735C2066.98 112.441 2069.79 115.14 2072.03 118.754C2073 118.087 2074.16 117.682 2075.41 117.682C2078.82 117.682 2081.59 120.727 2081.59 123.865C2081.59 127.13 2080.05 129.654 2077.85 130.725C2079.02 133.024 2080.21 134.693 2081.59 134.996C2086.94 134.455 2093.96 121.17 2093.96 110.261C2093.96 98.3212 2084.46 88 2066.75 88Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2101.38 283.404L2041.92 440.75L2000.24 556.723H1976.47L2033.76 283.404L2101.38 283.404Z",
    fill: "#4098CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2116.08 283.404C2116.72 337.393 2116.26 410.08 2117.76 413.445C2118.77 415.689 2149.99 441.252 2211.45 490.133L2199.2 510.963C2126.24 463.913 2087.89 437.253 2084.16 430.985C2078.57 421.582 2050.46 335.054 2035.83 283.404H2116.08Z",
    fill: "#9FCBE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2233 504.151L2212.31 488.404L2195.62 508.3C2194.33 523.298 2189.37 540.119 2180.72 558.762L2184.51 561.942L2214.72 525.941L2223.16 512.035L2225.05 513.625L2233 504.151Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2002.44 578.984L2001.2 553.013H1975.23C1962.92 561.67 1946.84 568.678 1927 574.037V578.984H1974L1990.07 576.511V578.984H2002.44Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2147.99 268.587L2122.15 268.688C2138.11 320.203 2146.72 347.536 2147.99 350.688C2150.86 357.78 2144.8 368.581 2142.21 374.386C2150.64 378.16 2149.75 364.183 2160.39 369.133C2170.1 373.651 2177.49 381.838 2188.71 374.914C2190.09 374.063 2191.6 370.858 2187.94 368.354C2178.85 362.114 2165.73 351.194 2163.96 347.6C2161.54 342.698 2156.22 316.36 2147.99 268.587ZM1996.53 267.587L1957.08 296.556C1946.38 299.443 1937.44 303.035 1930.26 307.332C1928.56 308.877 1926.51 312.006 1933.55 311.466C1940.58 310.925 1948 310.672 1948.97 313.071C1949.94 315.47 1945.69 318.338 1947.65 321.575C1948.96 323.732 1955.13 318.322 1966.18 305.344L2005.25 289.144L1996.53 267.587Z",
    fill: "#D4A181"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2074.55 160.141L2063.85 158.307C2024.18 192.584 2007.88 258.433 1959.24 293.316L1970.95 307.827C2055.32 297.38 2076.24 217.059 2074.55 160.141Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2121.17 294.535C2078.29 294.535 2046.75 294.535 2026.54 294.535C2022.22 294.535 2023.03 288.291 2023.66 285.141C2030.87 248.78 2059.03 209.585 2059.03 157.827L2086.33 153.547C2108.9 189.855 2116.71 234.559 2121.17 294.535Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2088.38 153.546C2087.46 153.546 2086.61 153.604 2085.85 153.719L2077.3 154.207C2052.78 237.292 2046.02 292.724 2057.01 320.505L2131.49 320.507C2135.9 330.796 2140.13 339.452 2144.16 346.477H2164.45C2166.36 284.723 2151.68 232.309 2120.41 189.235C2124.37 188.097 2127.51 185.439 2129.82 181.263C2139.8 163.262 2136.2 153.351 2125.54 150.094C2114.87 146.836 2105.37 153.546 2088.38 153.546Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2103.85 320.505L2131.49 320.506C2126.34 308.504 2120.94 294.28 2115.27 277.836C2112.93 297.432 2109.12 311.656 2103.85 320.505Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1037.92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowKeyvisualNew);
export default __webpack_public_path__ + "static/media/grow_keyvisual_new.974a0bf5cea074a8c07454e7263fc03f.svg";
export { ForwardRef as ReactComponent };